var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParticipantlist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.875 18.375V16.625C14.875 15.6967 14.5063 14.8065 13.8499 14.1501C13.1935 13.4937 12.3033 13.125 11.375 13.125H4.375C3.44674 13.125 2.5565 13.4937 1.90013 14.1501C1.24375 14.8065 0.875 15.6967 0.875 16.625V18.375M20.125 18.375V16.625C20.1244 15.8495 19.8663 15.0962 19.3912 14.4833C18.9161 13.8704 18.2509 13.4326 17.5 13.2388M14 2.73875C14.7529 2.93151 15.4202 3.36936 15.8967 3.98327C16.3732 4.59718 16.6319 5.35223 16.6319 6.12938C16.6319 6.90652 16.3732 7.66157 15.8967 8.27548C15.4202 8.88939 14.7529 9.32724 14 9.52M11.375 6.125C11.375 8.058 9.808 9.625 7.875 9.625C5.942 9.625 4.375 8.058 4.375 6.125C4.375 4.192 5.942 2.625 7.875 2.625C9.808 2.625 11.375 4.192 11.375 6.125Z",
    stroke: "#00D1B7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticipantlist);
export default __webpack_public_path__ + "static/media/participantlist.25f75aee6a3e327e972321542df7212e.svg";
export { ForwardRef as ReactComponent };